<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            Bei Weinexperten gilt das Weingut Heymann-Löwenstein als wichtiger Vertreter einer neuen Winzergeneration, die eine defensiv schonende und naturgemäße Weinbereitung anstrebt.
            Der Entwurf eines kubistisch modernen Neubaus schmiegt sich diametral an eine Villa aus der Jahrhundertwende an. Für den Neubau, einen schwarzen Kubus, entstanden unterschiedliche Fassadenentwürfe aus Aluminiumelementen.
            Der Entwurfsansatz spiegelt die Gegensätzlichkeit von High Tech und Low Tech sowie von Moderne und Tradition. Die Fassaden-entwürfe beruhen auf parametrisch computergenerierten Strukturen und die als Aluminiumelemente nach traditionellen Verfahren produziert wurden.

        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(3)"
            :link="links[3]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(6)"
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf und Realisierung</p>
            <p>Nico Reinhardt und Ying Wang</p>
            <br>
            <p class="font-semibold">Betreuung</p>
            <p>Prof. Markus Holzbach und Prof. Frank Georg Zebner,
                Hochschule für Gestaltung
                Offenbach am Main
            </p>
        </span>

    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/weingutloewenstein_1.jpg' ),
                require( '@/assets/img/pc/weingutloewenstein_2.jpg' ),
                require( '@/assets/img/pc/weingutloewenstein_3.jpg' ),
                require( '@/assets/img/pc/weingutloewenstein_4.jpg' ),
                require( '@/assets/img/pc/weingutloewenstein_5.jpg' ),
                require( '@/assets/img/pc/weingutloewenstein_6.jpg' ),
                require( '@/assets/img/pc/weingutloewenstein_7.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>